import {Box, Popover, Text, Title} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import {useRouter} from 'next/router';
import type React from 'react';
import {MdArrowBack, MdBookmark, MdOutlineHelp} from 'react-icons/md';
import {
  COMPANIES,
  FOLLOW_COMPANIES,
  MYPAGE_FAVS_COMPANIES,
} from '../../../../config/constants/routes';
import isAppWebView from '../../../../config/isAppWebView';
import {BreadcrumbsComponent} from '../../../../shared/components/BreadcrumbsComponent';
import {CommonLink} from '../../../../shared/components/CommonLink';

type Props = {
  pageTitle: string;
  crumbs: Array<{label: string; href: string}>;
  description?: string;
};

export const CompanyListHeader: React.FC<Props> = ({
  pageTitle,
  crumbs,
  description,
}) => {
  const [opened, {close, open}] = useDisclosure(false);

  const router = useRouter();
  const {id} = router.query;
  const industryId = Number(id) > 0 ? Number(id) : 0;

  return (
    <Box className="pt-8">
      <Box className="h-[25px] mx-16 pc:mx-0">
        <BreadcrumbsComponent crumbs={crumbs} />
      </Box>
      <Box className="my-16 mx-16 flex flex-row items-center justify-between gap-x-12 bg-white rounded-16 p-16 shadow-card pc:mx-0">
        <Box className="flex flex-col w-full">
          <Box className="flex w-full items-center justify-between">
            <Box className="flex items-center">
              {industryId > 0 && !isAppWebView() && (
                <CommonLink href={COMPANIES} className="pc:hidden">
                  <MdArrowBack
                    size={24}
                    className="bg-background rounded-[20px] p-4 mx-8 my-4"
                  />
                </CommonLink>
              )}

              <Title order={1} className="mr-16 text-lg">
                {pageTitle}
              </Title>
            </Box>
            <CommonLink
              className="font-bold text-black text-sm text-nowrap pc:text-base pc:hidden"
              href={FOLLOW_COMPANIES}
            >
              <Box className="flex bg-background-1 rounded-full p-8">
                <MdBookmark size={21} />
              </Box>
            </CommonLink>
          </Box>
          <Box className="flex flex-col">
            <Text className="text-black-1 text-base">
              {description
                ? description
                : 'インターン募集、セミナー、説明会、選考会など、外資・日系トップ企業の新卒採用に関する最新情報を随時掲載。'}
            </Text>
          </Box>
        </Box>
        <Box className="flex-col justify-between gap-4 hidden pc:flex">
          <Box className="w-full py-4 text-center border-2 border-primary rounded-full pc:py-8 cursor-pointer">
            <CommonLink
              className="font-bold text-primary text-sm text-nowrap px-16 pc:text-base"
              href={MYPAGE_FAVS_COMPANIES}
            >
              フォロー管理
            </CommonLink>
          </Box>
          <Popover opened={opened} onClose={close} position="bottom" withArrow>
            <Popover.Target>
              <Box
                className="flex items-center gap-4 text-black-1 cursor-pointer"
                onMouseEnter={open}
                onMouseLeave={close}
              >
                <MdOutlineHelp size={16} />
                <Text className="text-sm pc:text-base text-nowrap">
                  企業フォローとは
                </Text>
              </Box>
            </Popover.Target>
            <Popover.Dropdown>
              <Text className="w-[300px] text-base text-black-1 break-words">
                企業フォローとは、募集情報が公開されたり、企業情報が更新されたときに通知でお知らせする機能です。気になる企業をフォローすると最新情報を逃さずキャッチできます。
              </Text>
            </Popover.Dropdown>
          </Popover>
        </Box>
      </Box>
    </Box>
  );
};
